export const linkTags = [
  {
    rel: "sitemap",
    type: "application/xml",
    href: "https://bugoverdose.github.io/sitemap/sitemap-0.xml",
  },
];
